const background= '#011D43'; // Color de fondo del evento
const border= '#FAB900'; // Color del borde del evento
const text= '#FFFFFF'; // Color del texto del evento

export interface CalendarData{
    idAnuncio: number,
    idCategoria: number,
    txTitulo: string,
    dtPublicacion: string,
    dtVigencia: string,
    dtInicio: string,
    dtFin: string,
    dtEnvio: string,
    txTexto: string,
    txImagen: string,
    txUrl: string,
    bdTipo: string,
    bdAmbito: string,
    bdEstado: string,
    dtUltimoCambio: string,
    idGestor: number,
    idArea: number,
}

export function GetVoidCalendarData():CalendarData{
    return{
        idAnuncio: 0,
        idCategoria: 0,
        txTitulo: '',
        dtPublicacion: '',
        dtVigencia: '',
        dtInicio: '',
        dtFin: '',
        dtEnvio: '',
        txTexto: '',
        txImagen: '',
        txUrl: '',
        bdTipo: '',
        bdAmbito: '',
        bdEstado: '',
        dtUltimoCambio: '',
        idGestor: 0,
        idArea: 0,
    }
}

export interface CalendarEvent {
    idanuncio:number,
    title: string,
    start: Date,
    end?: Date,
    backgroundColor?: string, // Color de fondo del evento
    borderColor?: string, // Color del borde del evento
    textColor?: string, // Color del texto del evento
}

export function dataToEvent(data:CalendarData):CalendarEvent{
    return{
        idanuncio: data.idAnuncio,
        title: data.txTitulo,
        start: new Date(Date.parse(data.dtInicio)),
        end: new Date(Date.parse(data.dtFin)),
        backgroundColor: background, // Color de fondo del evento
        borderColor: border, // Color del borde del evento
        textColor: text,
    }
}

export function listDataToListEvent(data:Array<CalendarData>):Array<CalendarEvent>{
    let listEvent: Array<CalendarEvent> = [];
    data.forEach((item) => {
        const event: CalendarEvent = dataToEvent(item)
        listEvent.push(event);
    });
    return listEvent;
}